import React, { useEffect } from "react";

import { Link } from "gatsby";

import { useTheme } from "@emotion/react";
import styled from "@emotion/styled";

import useStore, {
    cartStorageKey,
} from "../../../../components/pages/Shop/ShoppingCart/store";
import { storageSession } from "../../../../utils/StorageHandler";
import { IconPredefined } from "../../icons/Icon";
import PredefinedIcon, {
    PredefinedIconType,
} from "../../icons/Icon/Predefined";
import { LinkItem, StyledIconContainer } from "../Desktop/TopRow/TopLinkItems";
import { TopRowItemWrapper } from "../Mobile/MobileItemsContainer/MobileModal";
import useNavigationStore from "../store";

export const CartQuantityIndicator = styled.span`
    position: absolute;
    top: -40%;
    right: -50%;
    display: inline-block;
    width: 1.1em;
    height: 1.1em;
    font-size: 0.85rem;
    font-weight: bold;
    line-height: 1.25em;
    color: ${({ theme }) => theme.colors.white.toString()};
    text-align: center;
    background-color: ${({ theme }) => theme.colors.blue.toString()};
    border-radius: 50%;
`;

const CartNav = styled.div`
    position: relative;
`;

const ShoppingCart = () => {
    const theme = useTheme();
    const [path] = useNavigationStore((state) => [state.path]);
    const { cart, fetchCart } = useStore((state) => ({
        cart: state.cart,
        fetchCart: state.fetchCart,
    }));

    useEffect(() => {
        if (!cart && storageSession.get(cartStorageKey)) {
            fetchCart();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    //Only display the Cart on shop related routes.
    if (!storageSession.get(cartStorageKey)) {
        return null;
    }

    return (
        <TopRowItemWrapper>
            <LinkItem to="/shop/warenkorb" active={path === "/shop/warenkorb"}>
                <StyledIconContainer>
                    <PredefinedIcon
                        type={PredefinedIconType.shop}
                        color={theme.colors.blue.toString()}
                    />
                    {cart?.lineItems && cart.lineItems.length > 0 && (
                        <CartQuantityIndicator>
                            {cart?.lineItems.length}
                        </CartQuantityIndicator>
                    )}
                </StyledIconContainer>
                <span>Warenkorb</span>
            </LinkItem>
        </TopRowItemWrapper>
    );
};

interface iCartIconProps {
    quantity: number;
    linkToCart?: string;
    style: object;
}
export const CartIcon = ({
    quantity = 0,
    linkToCart = "/shop/warenkorb",
}: iCartIconProps) => {
    const theme = useTheme();
    return (
        <Link to={linkToCart}>
            <CartNav>
                <IconPredefined
                    type={PredefinedIconType.shop}
                    size="1.25em"
                    color={theme.colors.blue.toString()}
                />
                {quantity > 0 && (
                    <CartQuantityIndicator>{quantity}</CartQuantityIndicator>
                )}
            </CartNav>
        </Link>
    );
};

export default ShoppingCart;
